import { getLocale } from "../runtime";

const sv_lvcountryenglish = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Latvia`
};

const lvcountryenglish = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_lvcountryenglish(inputs)
	return "lvCountryEnglish";
};

export { lvcountryenglish as "lvCountryEnglish" };